import * as React from "react";
import PropTypes from "prop-types";
import GBStdTable from "../../../Library/Tables/GBStdTable";
//import GBStdTable from '../../../Library/Tables/GBStdTableAG/GbStdTable';
import * as SCConst from "../NonComponents/SCConst.js";
import { getCategoryName } from "../NonComponents/SCDataUtil.js";
import * as Theme from "../../../App/Theme";

/* Everything should be declared in one placed. Change later. Copied these names from SCDataEntryDrawer. */
const numReachedByMobilStartRow = 1;
const numReachedByMobilTotalRow = 13;

const numSeekingVMMC_ServStartRow = 14;
const numSeekingVMMC_ServTotalRow = 26;

const infoSourcesStartRow = 27;
const infoSourcesTotalRow = 35;

const numVMMC_AgeGroups = 12;
const numInfoSources = 8;

const dataCol = 2;

/* Not from SCDataEntryDrawer ... yet. */
const lastRow = infoSourcesTotalRow + 1;
const lastCol = dataCol + 1;

class SCDemandTable extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        catInfo: PropTypes.object,
        indInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        value: PropTypes.arrayOf(PropTypes.array),
        onChange: PropTypes.func,
    };

    static defaultProps = {
        catInfo: null,
        indInfo: null,
        mstIDsObj: null,
        value: [
            ["", "", "Month"],
            ["Number of people reached by Mobilisers", "<1", 1],
            ["", "1-4", 2],
            ["", "5-9", 3],
            ["", "10-14", 4],
            ["", "15-19", 5],
            ["", "20-24", 6],
            ["", "25-29", 7],
            ["", "30-34", 8],
            ["", "35-39", 9],
            ["", "40-44", 10],
            ["", "45-49", 11],
            ["", "50+", 12],
            ["", "Total", numReachedByMobilTotalRow],
            ["Number people seeking for VMMC Services", "<1", 14],
            ["", "1-4", 15],
            ["", "5-9", 16],
            ["", "10-14", 17],
            ["", "15-19", 18],
            ["", "20-24", 19],
            ["", "25-29", 20],
            ["", "30-34", 21],
            ["", "35-39", 22],
            ["", "40-44", 23],
            ["", "45-49", 24],
            ["", "50+", 25],
            ["", "Total", numSeekingVMMC_ServTotalRow],
            ["Sources of information", "TV", 27],
            ["", "Radio", 28],
            ["", "Friends", 29],
            ["", "Family", 30],
            ["", "Mobilisers", 31],
            ["", "Community Leaders", 32],
            ["", "Posters", 33],
            ["", "Health Workers", 34],
            ["", "Total", infoSourcesTotalRow],
        ],
        onChange: () => console.log("onChange"),
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onSheetCellsChanged = (hot, newPackTable) => {
        try {
            let newPackTableClone = JSON.parse(JSON.stringify(newPackTable));
            let values2DArray = newPackTableClone.tableData.value;

            values2DArray[numReachedByMobilTotalRow][dataCol] = 0;
            values2DArray[numSeekingVMMC_ServTotalRow][dataCol] = 0;
            values2DArray[infoSourcesTotalRow][dataCol] = 0;

            for (let row = numReachedByMobilStartRow; row <= numReachedByMobilTotalRow - 1; row++) {
                if (values2DArray[row][dataCol] !== "") {
                    values2DArray[numReachedByMobilTotalRow][dataCol] =
                        values2DArray[numReachedByMobilTotalRow][dataCol] + values2DArray[row][dataCol];
                }
            }

            for (let row = numSeekingVMMC_ServStartRow; row <= numSeekingVMMC_ServTotalRow - 1; row++) {
                if (values2DArray[row][dataCol] !== "") {
                    values2DArray[numSeekingVMMC_ServTotalRow][dataCol] =
                        values2DArray[numSeekingVMMC_ServTotalRow][dataCol] + values2DArray[row][dataCol];
                }
            }

            for (let row = infoSourcesStartRow; row <= infoSourcesTotalRow - 1; row++) {
                if (values2DArray[row][dataCol] !== "") {
                    values2DArray[infoSourcesTotalRow][dataCol] =
                        values2DArray[infoSourcesTotalRow][dataCol] + values2DArray[row][dataCol];
                }
            }

            this.props.onChange(hot, newPackTableClone);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            let MAX_VALUE = 999999999;
            let styles = {
                innerPage: {
                    margin: 20,
                },
            };

            const catName = getCategoryName(SCConst.cat_DemandMstID, this.props.catInfo, this.props.mstIDsObj);

            let values = JSON.parse(JSON.stringify(this.props.value));

            let GBRowHeights = [];
            let minAllowedVal = [];
            let maxAllowedVal = [];
            let lockedCells = [];

            const numRows = lastRow;
            const numCols = lastCol;

            // experiment; instead of array.IndexOf(), trying a set.
            const demandTotalRowSet = new Set([
                numReachedByMobilTotalRow,
                numSeekingVMMC_ServTotalRow,
                infoSourcesTotalRow,
            ]);

            for (let row = 0; row < numRows; row++) {
                GBRowHeights.push(-1);
                minAllowedVal.push([]);
                maxAllowedVal.push([]);
                lockedCells.push([]);

                for (let col = 0; col < numCols; col++) {
                    if (row > 0 && col === dataCol) {
                        maxAllowedVal[row].push(MAX_VALUE);
                    } else {
                        maxAllowedVal[row].push(0);
                    }

                    if (row > 0 && !demandTotalRowSet.has(row) && col === dataCol) {
                        lockedCells[row].push(false);
                    } else {
                        lockedCells[row].push(true);
                    }

                    minAllowedVal[row].push(0);
                }
            }

            const packTable = {
                BandsOn: true,
                GBFixedRows: 1,
                GBFixedCols: 2,
                GBRowCount: numRows,
                GBColCount: numCols,
                GBColWidths: [425, 175, 125],
                GBRowHeights: GBRowHeights,
                MinAllowedVal: minAllowedVal,
                MaxAllowedVal: maxAllowedVal,
                LockedCells: lockedCells,
                MergedCells: [
                    {
                        startRow: numReachedByMobilStartRow,
                        startCol: 0,
                        numRows: numVMMC_AgeGroups + 1, // + total
                        numCols: 1,
                    },
                    {
                        startRow: numSeekingVMMC_ServStartRow,
                        startCol: 0,
                        numRows: numVMMC_AgeGroups + 1, // + total
                        numCols: 1,
                    },
                    {
                        startRow: infoSourcesStartRow,
                        startCol: 0,
                        numRows: numInfoSources + 1, // + total
                        numCols: 1,
                    },
                ],
                tableData: {
                    value: values,
                },
                AllowBlanks: true, // mark
            };

            return (
                <div style={styles.innerPage}>
                    <h5> {catName} </h5>

                    <GBStdTable
                        id="DemandTable"
                        minHeight={750}
                        maxHeight={750}
                        packTable={packTable}
                        onSheetCellsChanged={this.onSheetCellsChanged}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCDemandTableDiv"}
                    key={"SCDemandTableDiv"}
                >
                    <h3 key={"SCDemandTableDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCDemandTable;
